<div class="modal-header p-3 ps-4 bg-soft-primary">
  <h5 class="modal-title">{{ "t-proposals.t-promoter-email-title" | translate }}</h5>
  <button type="button" class="btn-close" [attr.aria-label]="'t-close' | translate" (click)="close()"></button>
</div>

<div class="modal-body p-4">
  <div class="text-center py-4" *ngIf="loading">
    <span class="spinner-border spinner-border-sm text-primary"></span>
  </div>
  <div class="alert alert-danger fs-13 mb-0" *ngIf="loadError">
    {{ "t-proposals.t-promoter-email-error" | translate }}
  </div>

  <form [formGroup]="form" *ngIf="!loading && !loadError">
    <div class="alert alert-warning py-2 fs-13" *ngIf="!ownerEmails.length">
      <i class="ri-information-line align-middle me-1"></i>
      {{ "t-proposals.t-promoter-email-no-owner" | translate }}
    </div>

    <div class="mb-3">
      <label class="form-label fs-13" for="promoterEmailTo">{{ "t-proposals.t-promoter-email-to" | translate }}</label>
      <ng-select labelForId="promoterEmailTo" formControlName="to" [items]="ownerEmails" [multiple]="true"
        [addTag]="addEmail" [addTagText]="'t-add' | translate" [selectOnTab]="true" [hideSelected]="true"
        [clearable]="false" [notFoundText]="'t-proposals.t-promoter-email-to-placeholder' | translate"
        [placeholder]="'t-proposals.t-promoter-email-to-placeholder' | translate"
        [ngClass]="{ 'is-invalid': submitted && !recipients.length }"
        (search)="onEmailSearch($event)" (blur)="commitPendingEmail()">
      </ng-select>
      <div class="invalid-feedback d-block" *ngIf="submitted && !recipients.length">
        {{ "t-proposals.t-promoter-email-invalid" | translate }}
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label fs-13" for="promoterEmailSubject">{{ "t-proposals.t-promoter-email-subject-label" | translate }}</label>
      <input id="promoterEmailSubject" type="text" class="form-control" formControlName="subject" maxlength="255"
        [ngClass]="{ 'is-invalid': submitted && form.get('subject')?.invalid }" />
    </div>

    <div class="mb-2">
      <label class="form-label fs-13" for="promoterEmailBody">{{ "t-proposals.t-promoter-email-body-label" | translate }}</label>
      <textarea id="promoterEmailBody" class="form-control" rows="14" formControlName="body"
        [ngClass]="{ 'is-invalid': submitted && form.get('body')?.invalid }"></textarea>
    </div>

    <div class="form-check form-switch mb-2" *ngIf="canReserve">
      <input class="form-check-input" type="checkbox" role="switch" id="promoterEmailReserve" formControlName="reserveProperty" />
      <label class="form-check-label fs-13" for="promoterEmailReserve">{{ "t-proposals.t-promoter-email-reserve" | translate }}</label>
      <div class="text-muted fs-12">{{ "t-proposals.t-promoter-email-reserve-hint" | translate }}</div>
    </div>

    <p class="text-muted fs-12 mb-0" *ngIf="replyTo">
      <i class="ri-reply-line align-bottom me-1"></i>
      {{ "t-proposals.t-promoter-email-reply-to-note" | translate: { email: replyTo } }}
    </p>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="close()">{{ "t-cancel" | translate }}</button>
  <button type="button" class="btn btn-primary" (click)="send()" [disabled]="loading || loadError || sending">
    <span class="spinner-border spinner-border-sm me-1" *ngIf="sending"></span>
    <i class="ri-mail-send-line align-bottom me-1" *ngIf="!sending"></i>
    {{ "t-proposals.t-promoter-email-send" | translate }}
  </button>
</div>
